<div id="myModal" class="modal fade" role="dialog" style="padding-bottom: 5px; height: 99%;">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body text-center" style="position: relative">
        <div>
          <button
            type="button"
            class="close"
            style="float: right; color: white; background-color: red"
            (click)="closeModal()"
            aria-hidden="false"
          >
            ×
          </button>
          <ng-container *ngIf="modal != null">
          <ng-container
            *ngIf="modal.DetailsEn != null && modal.ShowAttachments == null"
          >
            <span [innerHTML]="modal.DetailsEn"></span>
          </ng-container>
          <ng-container
            *ngIf="modal.DetailsEn != null && modal.ShowAttachments != null"
          >
            <img [src]="modal.ShowAttachments[0].FilePath" alt="image" />
          </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
